import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import { DOCUMENT } from "@angular/common";
import {CITY} from "../tokens";

@Injectable({
    providedIn: "root"
})
export class TranslationService {

    private readonly SUPPORTED_LANGUAGES: Record<string, Langs> = {
      en: {
        code: 'en',
        docLang: 'en-EN'
      },
      bg: {
        code: 'bg',
        docLang: 'bg-BG'
      },
      mk: {
        code: 'mk',
        docLang: 'mk-MK'
      },
      sr: {
        code: 'sr',
        docLang: 'sr-SR'
      }
    };

    // Default language
    private readonly DEFAULT_LANGUAGE = 'bg';

    private routerInfo: BehaviorSubject<boolean>;
    word: {};
    language: string;
    city: string;
    constructor(
        private localStorage: LocalStorageService,
        @Inject(DOCUMENT) private document,
        @Inject(CITY) private injectedCity: string
    ) {

      this.city = this.injectedCity || JSON.parse(this.localStorage.getItem('city') || 'null');
      const currentUrl = this.document.defaultView.location.href;
      // Check for language code in URL
      let languageCode = this.getLanguageFromUrl(currentUrl);

      const isEnglish = languageCode === 'en';
      if (languageCode === this.DEFAULT_LANGUAGE && this.city === 'beograd'){
        languageCode = 'sr';
      }

      if (languageCode === this.DEFAULT_LANGUAGE && this.city  === 'skopje'){
        languageCode = 'mk';
      }

      this.routerInfo = new BehaviorSubject<boolean>(isEnglish);

      // Initialize language
      this.setLanguage(languageCode);


        this.word = {
            "bg": {
                //days of the week//
                "monday": "Понеделник",
                "tuesday": "Вторник",
                "wednesday": "Сряда",
                "thursday": "Четвъртък",
                "friday": "Петък",
                "saturday": "Събота",
                "sunday": "Неделя",
                // new 10.2021
                "restaurants": "Ресторанти",
                "allcatvenues": "ВСИЧКИ КАТЕГОРИИ ЗАВЕДЕНИЯ",
                "topic": "Поводи",
                "musictype": "Музика",
                "footerInfo1": "Zavedenia.bg - каталог за заведения София, Пловдив, Варна, Банско. Актуална информация за заведенията в България.",
                "footerInfo2": "Изберете ресторант, бар, клуб, механа или пицария. Резервирайте маса онлайн. Вижте актуални оферти и събития. Ресторанти за специални поводи, ресторанти с различен тип кухня.",
                "footerForClients": "За посетители",
                "footerForPartners": "За партньори",
                "footerAbout": "За нас",
                "footerFollowUs": "Последвайте ни",
                "footerSites": "Мрежа сайтове",
                "addVenue": "Добави заведение",
                "help": "F.A.Q.",
                "feedback": "Обратна връзка",
                "forInvestors": "За инвеститори",
                "development": "Дейност",
                "termsOfUse": "Условия за ползване",
                "personalData": "Лични данни",
                "contacts": "Контакти",
                "downloadOurApp": "Инфо приложение за всяко заведение! Изтеглете сега!",
                "zavedeniaApp": "Z App ще ти помогне да намериш най-близките ресторанти, барове, клубове до теб. Виж офертите. Избери заведение. Резервирай онлайн.",
                "zavedenia": "Заведения",
                "lastPosts": "Последни публикации",
                "seeAll": "виж всички",
                "mostViewed": "Най-разглеждани",
                "seeOurBlog": "Разгледай блог страницата ни",
                "seeMore": "Виж повече",
                "recommended": "Препоръчано от нас",
                "selectedForYou": "Селектирани за вас",
                "lastAdded" : "Последно обновени",
                "lastActive": "Последно активни",
                "lastReservations": "Скорошни резервации",
                "lastVisited": "Разгледани заведения",
                "makeReservation": "Направи резервация",
                "changeLang": "EN",
                "changeLangBG": "BG",
                "all": "Всички",
                "resultsFor": "Резултати за",
                "noResults": "Няма намерени резултати за: ",
                "seats": "Места",
                "capacityIn": "вътре",
                "capacityOut": "вън",
                "prices": "Цени",
                "webbsite": "Уебсайт",
                "openMap": "Отвори карта",
                "map" : "Карта",
                "list": "Лист",
                "aboutVenue": "За заведението",
                "hideDesc": "Скрий описанието",
                "notAddedInfo": "Заведението все още не е публикувало информация на профила си.",
                "comingInfoSoon": "Очаквайте актуализация или разберете повече на посочения телефон.",
                "thankUnderstanding": "Благодарим за разбирането.",
                "suitableFor": "Подходящо За",
                "typeVenue": "Тип Заведение",
                "extras": "Екстри",
                "events": "Събития",
                "news": "Новини",
                "photos": "Снимки",
                "offers": "Оферти",
                "comments": "Коментари",
                "video": "Видео",
                "seeTheArticle": ".. разгледайте статията",
                "CommentBook": "Книга за гости",
                "leaveComment": "Остави коментар",
                "from": "от",
                "Manager": "от Управител",
                "ThematicGalleries": "Тематични галерии",
                //end new
                // 1.11.2021 bg
                "venueCategories": "Категории заведения",
                "program": "Програма",
                "partyPeople": "Парти Снимки",
                "ownersLogin": "Вход за собственици",
                //
                "search": "Търси",
                "venue": "Ресторант",
                "venueZav": "заведение",
                "by": "По",
                "category": "Категория",
                "blog": "Блог",
                "for": "За",
                "type": "Тип",
                "kitchen": "кухня",
                "theBusiness": "Бизнеса",
                "sofia": "София",
                "plovdiv": "Пловдив",
                "varna": "Варна",
                "burgas": "Бургас",
                "tarnovo": "В. Търново",
                "bansko": "Банско",
                "skopje": "Скопие",
                "beograd": "Белград",
                "others": "Всички останали",
                "home": "Начало",
                "city": "Град",
                "choose": "Избери",

                "searchByCuisine": "Търси ресторант по тип кухня",
                "searchPlaceHolder": "Търси ресторант, храна или кухня",
                "ad": "Реклама",
                "orderFood": "Поръчай храна",
                "venues": "ресторанти, пицарии, барове, клубове",
                "zavedeniaBG": "Zavedenia",
                "foodForHome": "Храна за вкъщи",
                "bookTable": "Резервирай маса",
                "lang": "BG",
                "website": "Уебсайт",
                "address": "Адрес",
                "ALL": "ВСИЧКО",
                "area": "Квартал",
                "back": "Назад",
                "order": "Поръчай",
                "change": "Промени",
                "close": "Затвори",
                "closed": "Затворено",
                "comment": "Коментар",
                "DISCOUNT": "ОТСТЪПКА",
                "discountShort": "отстъпка",
                "email": "Емейл",
                "info": "Инфо",
                "moreinfo": "Повече информация",
                "login": "Вход",
                "menu": "Меню",
                "name": "Име",
                "names": "Имена",
                "next": "Продължи",
                "open": "Отворено",
                "visits": "Посещения",
                // "order" : "Поръчка",
                "ORDER": "Поръчката",
                "password": "Парола",
                "phone": "Телефон",
                "plasticBox": "Опаковка(и)",
                "price": "цена",
                "profile": "Профил",
                "quantity": "Количество",
                "save": "Запази",
                "shippingPrice": "Доставка",

                //change to deliveryPrice
                "sum": "Общо",
                "take": "Вземете",
                "taken": "Взимане",
                "registration": "Регистрация",

                // two words
                "fineDining": "Файн Дайнинг",
                "european": "Европейска",
                "grill": "Скара, барбекю",
                "italian": "Италианска",
                "asian": "Азиатска",
                "arabic": "Арабска",
                "bulgarian": "Българска",
                "oriental": "Източна",
                "sushi": "Суши",
                "mediterranean": "Средиземно-морска",
                "latin": "Латино-американска",
                "streetFood": "Стрийт фууд",

                "fastFood": "Бързо хранене",
                "turkishFood": "Турска",
                "sandwiches": "Сандвичи",
                "serbianFood": "Сръбска кухня",
                "international": "Интернационална",
                "japanese": "Японска",
                "seafood": "Морска Храна",
                "american": "Американска",
                "greek": "Гръцка",

                "burgers": "Бургери",
                "vegetarian": "Веган - вегетарианска",
                "indian": "Индийска",
                "balkan": "Балканска",
                "myOrder": "Моята поръчка",
                "changeAddress": "Редактирай адрес",
                "createProfile": "Създай профил",
                "forgotten": "Забравена парола",
                "username": "Емейл адрес",
                "sendPassword": "Изпрати парола",
                "forgottenPassword": "Забравена парола",
                "withoutRegistration": "Нямате регистрация",
                "commentFoodNotes": "Допълнителни инструкции",
                "discount": "Направена отстъпка",
                "mainAddress": "Основен адрес",
                "toBasket": "Към кошницата",
                "selectArea": "Избери квартал",
                "totalWithDelivery": "С ДОСТАВКА",
                "totalPickUp": "НА МЯСТО",
                "emptyTheBasket": "Изпразни кошницата",
                "subtotal": "Междинна сума",
                "wrongEmail": "Невалиден емейл",
                "workingTime": "Работно време",
                "checkCode": "Провери код",
                "lastOrderButton": "ВИЖ ПОРЪЧКАТА",
                "enterAddress": "Въведете адрес",
                "takeOnPlace": "на място",
                "shippingFrom": "Доставка от",
                "onquestions": "При въпроси:",
                "checkverifycode": "Провери кода",

                //three words
                "pay": "Плати с карта",
                "orderCash": "Плати в брой",
                "orderCard": "Плати с карта",
                "boxes": "Кутии и опаковки",
                "registrationForm": "Форма за регистрация",
                "chooseCity": "Избери твоя град",
                "chooseArea": "Избери твоя квартал",
                "phoneForContacts": "Телефон за контакт",
                "youAddedAddress": "Успешно добавихте адрес!",
                "itemsInTheBasket": "Продукти в кошницата",
                "basketIsEmpty": "Кошницата е празна",
                "productsPrice": "Цена на продуктите",
                "shippingInfo": "Информация за поръчката",
                "changeMainAddress": "Смени основния адрес",
                "editMainAddress": "Редактирай адрес",
                "addAddress": "Добави нов адрес",
                "shippings": "Приемане на поръчки",
                "getCode": "Изпрати нов код",
                "placeholderCode": "Добави кода тук",
                "continueNoReg": "Продължи без регистрация",
                "logWithEmail": "Влез с email",
                "dontLogMe": "Не, не искам",
                "enterYourAddress": "въведете адрес си",
                "continueWithoutReg": "Продължи без регистрация",
                "emptyPassword": "Не сте въвели парола",
                "errorPasswordShort": "Паролата е твърде къса",
                "emptyUsername": "Не сте въвели потребителско име",
                "orderIsAcceptedStatusOne": "Поръчката Ви се обработва...", //за потвърждение че е приета
                "orderIsAcceptedStatusTwo": "Поръчката Ви е приета!", //
                "emptyEmail": "Не сте въвели email",
                "usedEmail": "Електронната поща се използва",
                "shippingArea": "Квартал за получаване на поръчките",
                "shippingAddress": "Адрес за получаване на поръчките",
                "emptyAddress": "Не сте въвели адрес",
                "emptyPhone": "Не сте въвели телефон",
                "myFavorite": "Найчесто поръчвани от мен",
                "shippingAddressIsChanged": "Успешно променихте адреса за доставка",
                "yourAddressIsChanged": "Успешно променихте адреса си",
                "yourProfileIsChanged": "Успешно променихте профила си",
                "logout": "Влез с друг профил",
                "passwordIsSended": "Паролата Ви беше изпратена успешно на посочената електронна поща",
                "withoutShipping": "Няма да успеем да доставим до адреса Ви.",
                "withoutShippingNow": "Заведението не доставя през това време от деня! Часовете и дните, в които се извършва доставка може да видите в секция 'ИНФО'",
                "pleaseSinginWithPayment": "Искате ли да се регистрирате с email?\nПлащане с карта е възможно само с регистрация. ",
                "pleaseSingin": "Искате ли да се регистрирате с email? \n Цената за доставка ще е подобра!",
                "itemIsAdded": "Добавихте продукт в кошницата!",
                "tryAgain": 'Възникна грешка при изпращането на поръчката Ви! Моля натиснете бутон "Поръчай" отново след няколко секунди',
                "sumIsNotOne": "Не сте достигнал сумата от ",
                "sumIsNotTwo": " лв, за да приемем поръката",
                "leavecomment": "Оставете коментар към поръчката",
                "lv": "лв",

                //new
                "backToMenu": "Обратно към Менюто",
                "doesNotDeliver": "Не доставяме до адреса Ви :(",
                "minimalOrder": "МИНИМАЛНА СУМА ЗА ПОРЪЧКА ИЛИ ПОРЪЧАЙ НА МЯСТО:",
                "emptyBasket": "Нямате продукти в кошницата",
                "codeTimeMessage": "Моля въведете кода, преди да е изтекло времето",
                "codeResend": "Моля препратете кода отново.",
                "codeTypeIt": "Моля въведете своя код за верификация.",
                "registerDiscount": "Ще получите подобра цена за доставка :)",
                "termsAgreement": "Съгласен съм с условията за поръчка и обработка на личните данни",
                "paywithcardMessage": "Може да платиш бързо и сигурно с карта",
                "addressIsRequired": "Адресът е задължителен",
                "commentAdditionalInfo": "В коментар посочете етаж/апартамент или други подробности.",
                "paymentsOnlyWithReg": "Плащане с карта е възможно, ако имате регистрация!",
                "naberRestriction": "Заведението не доставя в твоя квартал :(",
                "noOrderInTheMoment": "Не приемаме поръчки в момента",
                "quantityCount": "бр.",
                "deliveryOnPlaceByVenueComment": "Ако желаете да Ви доставим на място  попълнете адреса си като коментар!",
                "orOrderFor": "или поръчайте за",
                "homeOrOffice": "вкъщи или офиса",
                "orderPromotion1608": "Поръчай 2 пици 30 см, вземи пица Маргарита безплатно",
                "freeDeliveryPlus": "Безплатна доставка",
                "ORDERS": " поръчка на храна",
                "orderIsPayed": "Поръчката Ви е платена! Благодарим за доверието.",
                "bannerPromotionVenue": "Поръчай от нас и получи отстъпка",
                "bannerPromotionVenueMinPriceDiscount": "Важи само за поръчки над ",
                "orOrderIn": "или доставка в",
                "or": "or",
                "orDeliveryUpTo": "доставка до адрес.",
                "infoFooterDescriptionFirstParagraph": "ORDER.BG е услуга на ZAVEDENIA.BG и представлява индивидуална платформа за поръчка на храна за вкъщи от ресторанти.",
                "infoFooterDescriptionSecondParagraph": "В случай, че заведението приема плащане с карти и имате въпрос относно транзакция, може да се свържете с нас на",
                "keywordss": "поръчай храна, храна за вкъщи, доставки на храна, доставки до офиса, поръчай, доставка, на място, за вкъщи, храна, ястия, обед, вечеря, София, Пловдив, Варна",
                "descriptionn": "Поръчай от любимата хрнана за вкъщи. Вземете на място или ние ще доставим до офиса или до вкъщи  София, Пловдив, Варна",
                "verifyHeader": "Натиснете бутона за да изпратим SMS с код!",
                "verifySentence": "Моля, препратете кода отново.",
                "verifySentence2": "Твърде много опити за верификация на телефона, моля обади се на тел за повече инфо.",
                "verifywrongcode": "Кодът беше изпратен като SMS",
                "verifywrongcode2": "Грешен код, моля опитайте пак",
                "sendverifycode": "ИЗПРАТИ МИ КОДА СЕГА!",
                "enterverifycode": "Добави кода тук",
                "orderfoodhome": "Поръчай храна за вкъщи",
                "noDeliveryCalculated": "Доставката се изчислява в кошницата",
                "gr": 'гр',
                "ml": 'мл',
                "br": 'бр',
                "couldOpen1": "Заведението все още не работи, НО може да поръчате.",
                "couldOpen2": "може да видите кога отваря.",
                "noPlaceOrder": "Заведението не предлага доставка на място!",
                "addressNotMatch": 'Адресът ви не е в зоната за доставка!',
                "address_enter": 'Въведи адрес (без етаж/апт)',
                "TakeFromVenueOrDeliveryZone": 'Взимане на място или доставка в следните квартали',
                "TakeFromVenueOrDelivery": 'Взимане на място или доставка до адрес',
                "searchInputPlaceHolder": 'Въведи адреса си',
                // BOOKING
                "bookingFormText1": 'Резервирай маса в заведението',
                "bookingFormText2": 'Онлайн резервации booky.bg',
                "bookingFormText3": 'Вашата резервация стига веднага в заведението',
                "bookingFormText4": 'Получавате SMS при потвърждение',
                "bookingFormText5": 'Получавате напомняне за резервация',
                "bookingFormText6": 'Получавате линк за обратна връзка, която стига до управител',


                //SEO
                "seoMenu": 'меню',
                "seoNews": 'новини',
                "seoOffers": 'оферти',
                "seoEvents": 'събития',
                "seoPictures": 'снимки',
                "seoVideos": 'видео',
                "seoKeywords1": 'ресторанти, заведения, ресторант в ',
                "seoKeywords2": ', бар, клуб, механа, пица, пицария, летни градини, ресторанти сватба, ресторанти детски кът, резервирай маса, резервации, поръчай храна, барове, нощни клубове',
                "seoKeywordsMap": 'карта, локация, адрес, заведения, ресторанти, механи, частни, фирмени, партита, абитуриентски бал, рожден ден, кръщене, сватба, бизнес среща, летни, градини',
                "seoDescriptionCity1": 'Ресторанти, барове, клубове в ',
                "seoDescriptionCity2": '.  Резервирай онлайн, поръчай за вкъщи. Избрани механи, бирарии, ресторанти за сватби, фирмени и частни партита.',
                "seoDescriptionMap": ` Локация любими ресторанти за частни и фирмени партита, абитуриентски бал, рожден ден, сватби. Заведения с летни градини.`,
                "seoDescriptionAlt" : 'Ресторанти, барове, клубове',
                "seoDescriptionOg": 'Известни, луксозни, любими ресторанти, барове, клубове. Ресторанти за сватби, фирмени и частни партита. Резервирай маса. Поръчай за вкъщи',
                "seoSiteName" : 'Zavedenia',
                "seoTitle1": 'Ресторанти',
                "seoTitle2": 'Заведения.бг',
                 //top
                 "topMediterraneanKitchen": 'ТОП средиземноморска кухня',
                 "topClubs": 'ТОП Нощни клубове',
                 "topClassVenues": 'ТОП изискани ресторанти',
                 "topClassVenuesVarna": 'ТОП ресторанти',
                 "topPizza": 'ТОП пицарии',
                 "topBulgarianPub": 'ТОП механи',
                 "topBars": 'ТОП барове',
                 "topDelivery": 'Най-търсени за доставка',
                 "beerVenues": 'Топ места за бира',
                 "topBarAndDinner": 'ТОП бар и динър заведения',
                 "fishRestourants": 'Топ рибни ресторанти',
                 "top25": 'ТОП 25 за месеца',
                "emptyList": "Тук вече няма резултати. Опитайте да промените вашия филтър или изберете друга категория.",
                "interestingFromZavedenia": "Интересно от заведенията и София"

            },
            "en": {
              //days of the week
              "monday": "Monday",
              "tuesday": "Tuesday",
              "wednesday": "Wednesday",
              "thursday": "Thursday",
              "friday": "Friday",
              "saturday": "Saturday",
              "sunday": "Sunday",
                // new 10.2021
                "restaurants": "Restaurants",
                "allcatvenues": "ALL VENUES CATEGORIES",
                "topic": "Оccasions",
                "musictype": "Music",
                "footerInfo1": "Zavedenia.bg - online catalog for restaurants and bars in Sofia, Plovdiv, Varna, Bansko",
                "footerInfo2": "Choose a restaurant, bar, club, tavern, pizzeria. Book a table. See current offers and events. Restaurants for special occasions, with different types of cuisine.",
                "footerForClients": "For clients",
                "footerForPartners": "For partners",
                "footerAbout": "About us",
                "footerFollowUs": "Follow us",
                "footerSites": "Our sites",
                "addVenue": "Add a restaurant",
                "help": "F.A.Q.",
                "feedback": "Feedback",
                "forInvestors": "For Investors",
                "development": "Development",
                "termsOfUse": "Terms of Use",
                "personalData": "Personal Data",
                "contacts": "Contacts",
                "downloadOurApp": "Download our restaurant and bars app",
                "zavedeniaApp": "Z App will help you find the nearest restaurants, bars, clubs next to you. Check the offers. Choose a restaurant. Book a table.",
                "zavedenia": "Venues",
                "lastPosts": "Last Posts",
                "seeAll": "see all",
                "mostViewed": "Most viewed",
                "seeOurBlog": "View our blog page",
                "seeMore": "See more",
                "recommended": "Recommended",
                "selectedForYou": "Selected for you",
                "lastActive": "Last Active",
                "lastAdded" : "Last Updated",
                "lastReservations": "Recent Reservations",
                "lastVisited": "Last Visited profiles",
                "makeReservation": "make a reservation",
                "changeLang": "EN",
                "changeLangBG": "BG",
                "all": "All",
                "resultsFor": "Results for",
                "noResults": "No results found for:",
                "seats": "Seats",
                "capacityIn": "inside",
                "capacityOut": "out",
                "prices": "Prices",
                "website": "Website",
                "openMap": "Open map",
                "map" : "Map",
                "list": "List",
                "aboutVenue": "About the restaurant",
                "hideDesc": "Hide description",
                "notAddedInfo": "The restaurant has not yet posted any information.",
                "comingInfoSoon": "Info coming soon. Find out more on the specified phone.",
                "thankUnderstanding": "Thank you for your understanding.",
                "suitableFor": "Suitable For",
                "typeVenue": "Type Restaurant",
                "extras": "Extras",
                "events": "Events",
                "news": "News",
                "photos": "Photos",
                "offers": "Offers",
                "comments": "Comments",
                "video": "Video",
                "seeTheArticle": ".. view article",
                "CommentBook": "Guestbook",
                "leaveComment": "leave a comment",
                "from": "from",
                "Manager": "by Manager",
                "ThematicGalleries": "Thematic Galleries",

                // end new
                // 1.11.2021 en
                "venueCategories": "Категории заведения",
                "program": "Програма",
                "partyPeople": "Парти Снимки",
                "ownersLogin": "Вход за собственици",
                //
                "search": "Search",
                "venue": "Venue",
                "venueZav": "venue",
                "by": "By",
                "category": "Category",
                "blog": "Blog",
                "for": "For",
                "type": "Type",
                "kitchen": "Cuisine",
                "theBusiness": "The Business",
                "sofia": "Sofia",
                "plovdiv": "Plovdiv",
                "varna": "Varna",
                "burgas": "Burgas",
                "tarnovo": "Veliko Tarnovo",
                "bansko": "Basnko",
                "skopje": "Skopje",
                "beograd": "Belgrade",
                "others": "Ohters",
                "home": "Home",
                "city": "City",
                "choose": "Choose",

                "searchByCuisine": "Search by cuisine type",
                "searchPlaceHolder": "Search for restaurants, type or kitchen",
                "fineDining": "Fine Dining",
                "european": "European",
                "grill": "Grill, BBQ",
                "italian": "Italian",
                "asian": "Asian",
                "arabic": "Arabic",
                "bulgarian": "Bulgarian",
                "oriental": "Oriental",
                "sushi": "Sushi",
                "mediterranean": "Mediterranean",
                "latin": "Latin-american",
                "streetFood": "Street Food",
                "fastFood": "Fast Food",
                "turkishFood": "Turkish",
                "sandwiches": "Sandwiches",
                "serbianFood": "Serbian",
                "international": "International",
                "japanese": "Japanese",
                "seafood": "Sea Food",
                "american": "American",
                "greek": "Greek",
                "burgers": "Burgers",
                "vegetarian": "Vegan - vegetarian",
                "indian": "Indian",
                "balkan": "Balkan",
                "ad": "Advertising",
                "orderFood": "Order Food",
                "venues": "restaurants, pizza, bars, pubs",
                "zavedeniaBG": "Zavedenia",
                "foodForHome": "Order food",
                "bookTable": "Book a table",
                "lang": "EN",

                "profile": "Profile",
                "menu": "Menu",
                "info": "Info",
                "moreinfo": "More information",
                "login": "Log in",
                "createProfile": "Create Account",
                "forgotten": "Forgotten password",
                "back": "Back",
                "backToMenu": "Back to Menu",
                "close": "Close",
                "username": "Username",
                "password": "Password",
                "myOrder": "My order",
                "changeAddress": "Change address",
                "emptyPassword": "You haven’t added a password",
                "errorPasswordShort": "Password too short",
                "emptyUsername": "You haven’t added a username",
                "sendPassword": "Send password",
                "forgottenPassword": "Forgotten password",
                "withoutRegistration": "No registration",
                "orderIsAcceptedStatusOne": "Your order is being processed...", //for confirmation that it is accepted
                "orderIsAcceptedStatusTwo": "Your order has been accepted!", //
                "registrationForm": "Registration form",
                "name": "Name",
                "names": "Names",
                "email": "Email address",
                "subtotal": "Subtotal",
                "addressIsRequired": "Address is required",
                "emptyEmail": "You haven’t added an email address",
                "wrongEmail": "The email address is invalid",
                "usedEmail": "The email address is already in use",
                "shippingArea": "Area",
                "chooseCity": "Choose city",
                "chooseArea": "Choose your area",
                "shippingAddress": "Address",
                "emptyAddress": "You haven’t added address",
                "phoneForContacts": "Phone number",
                "emptyPhone": "Must add a phone number",
                "next": "Next",
                "price": "Price",
                "quantity": "Quantity",
                "comment": "Comment",
                "toTheBasket": "To the basket",
                "myFavorite": "My top orders",
                "youAddedAddress": "You have successfully added address!",
                "area": "Area",
                "selectArea": "Select an area",
                "address": "Address",
                "phone": "Phone",
                "save": "Save",
                "commentFoodNotes": "Additional notes",
                "itemsInTheBasket": "Items in the basket",
                "basketIsEmpty": "The basket is empty",
                "productsPrice": "Products’ price",
                "boxes": "Boxes and packaging",
                "discount": "Discount made",
                "shippingPrice": "Delivery",
                "sum": "Total",
                "shippingInfo": "Delivery information",
                "changeMainAddress": "Change the main address",
                "emptyTheBasket": "Empty the basket",
                "shippingAddressIsChanged": "You have successfully changed your delivery address",
                "yourAddressIsChanged": "You have successfully changed your address",
                "yourProfileIsChanged": "You have successfully changed your profile",
                "mainAddress": "Main address",
                "editMainAddress": "Edit main address",
                "addAddress": "Add a new address",
                "logout": "Log out",
                "workingTime": "Working hours",
                "shippings": "Accepting deliveries",
                "passwordIsSended": "Your password has been successfully sent to the your email address",
                "withoutShipping": "Unfortunately we don’t ship in the requested area",
                "withoutShippingNow": "The venue does not accept orders during those hours! The hours and days in which deliveries are made can be checked in section “INFO”",
                "pleaseSinginWithPayment": "Would you like to sign up with an email address?\nPaying with a credit/debit card is possible only with registration.",
                "pleaseSingin": "Would you like to sign up with an email address?",
                "itemIsAdded": "You’ve added an item!",
                "tryAgain": "There was an error submitting your delivery! Please click the button “Order” again in a few seconds",
                "sumIsNotOne": "You haven’t reached the minimum amount of ",
                "sumIsNotTwo": " lv, in order to accept the order",
                "leavecomment": "Leave a comment for the order",
                "lv": "lv",
                "pay": "Pay with card",
                "orderCash": "Pay in cash",
                "orderCard": "Pay with card",
                "totalWithDelivery": "WITH DELIVERY",
                "totalPickUp": "WITH PICK UP",
                "orderfoodhome": "Order food for home",
                "doesNotDeliver": "We cannot deliver in your area :(",
                "minimalOrder": "MINIMUM ORDER AMOUNT:",
                "order": "Order",
                "visits": "Visits",
                "discountShort": "Discount",
                "plasticBox": "Packaging:",
                "emptyBasket": "Empty basket",
                "codeTimeMessage": "Please enter your code here",
                "codeResend": "Please resend the code again.",
                "codeTypeIt": "Please input the verification code",
                "checkCode": "Verify my code",
                "getCode": "Send me a new code",
                "placeholderCode": "Add your code here",
                "continueNoReg": "Continue without registration",
                "registerDiscount": " ",
                "change": "Edit",
                "termsAgreement": "I agree with the terms and privacy policies of the site",
                "paywithcardMessage": "You can pay by card",
                "commentAdditionalInfo": "Please write floor/apartment or other details in the box.",
                "lastOrderButton": "YOUR ORDER",
                "logWithEmail": "I want to register",
                "dontLogMe": "I will do a quick order",
                "naberRestriction": 'We can"t deliver in your area :(',
                "enterAddress": "Enter address",
                "enterYourAddress": " enter adress here",
                "noOrderInTheMoment": "We are not delivering now :(",
                "quantityCount": "бр.",
                "deliveryOnPlaceByVenueComment": "Please leave precise address and other details in the comment box below!",
                "take": "Pick up",
                "taken": "Pickup",
                "registration": "Registration",

                "takeOnPlace": "from the restaurant",
                "orOrderFor": " or order ",
                "homeOrOffice": " delivery",
                "orderPromotion1608": "Order 2 пици 30 см, вземи пица Маргарита безплатно",
                "shippingFrom": "Delivery from ",
                "freeDeliveryPlus": "Free delivery ",
                "DISCOUNT": "DISCOUNT",
                "ORDERS": "ORDERS",
                "onquestions": "If any questions:",
                "ORDER": "Order",
                "orderIsPayed": "Your order is paid! Thank you.",
                "ALL": "Total",
                "bannerPromotionVenue": "Order here and get discount",
                "bannerPromotionVenueMinPriceDiscount": "Важи само за поръчки над ",
                "orOrderIn": " or delivery ",
                "or": "or",
                "orDeliveryUpTo": " home delivery.",
                "infoFooterDescriptionFirstParagraph": "ORDER.BG is a service of ZAVEDENIA.BG and is a shared platform for food ordering.",
                "infoFooterDescriptionSecondParagraph": "In case you have paid online and have questions about your transaction, please get in touch with us at ",
                "open": "Open",
                "closed": "Closed",
                "keywordss": "order food, food for home, food delivery, delivery to the office, order, delivery, for home, food, dishes, lunch, dinner, Sofia, Plovdiv, Varna",
                "descriptionn": "Order food from your favorite restaurant and cuisine. Take away food or we will deliver to your home  Sofia, Plovdiv, Varna",
                "verifyHeader": "Press the button to send you code via SMS.",
                "verifySentence": "Please send the code again!",
                "verifySentence2": "Too many attempts. Please try another phone.",
                "verifywrongcode": "We sent the code, please check your sms messages or try again.",
                "verifywrongcode2": "Wrong code, please try again",
                "sendverifycode": "Send me the code!",
                "enterverifycode": "Enter code here",
                "checkverifycode": "Check the code",
                "noDeliveryCalculated": "We calculate delivery in the basket",
                "gr": 'gr',
                "ml": 'ml',
                "br": 'pc',
                "couldOpen1": "We are still closed, but you can order in advance.",
                "couldOpen2": " We will open soon.",
                "noPlaceOrder": "We don't offer pickup service.",
                "addressNotMatch": 'Your address is not in the delivery zone!',
                "address_enter": 'Enter your address (street and number)',
                "TakeFromVenueOrDeliveryZone": 'Take away or use delivery to the following neighborhoods',
                "TakeFromVenueOrDelivery": 'Take away or use delivery to correct address',
                "searchInputPlaceHolder": 'Search your address',

                 // BOOKING
                "bookingFormText1": 'Book a table online',
                "bookingFormText2": 'Online bookings by booky.bg',
                "bookingFormText3": 'Your information is sent immediately to the venue',
                "bookingFormText4": 'You receive SMS confirmation',
                "bookingFormText5": 'You receive reminder for your booking',
                "bookingFormText6": 'Your feedback will be sent directly to the manager',


                //SEO
                "seoMenu": 'menu',
                "seoNews": 'news',
                "seoOffers": 'offers',
                "seoEvents": 'events',
                "seoPictures": 'pictures',
                "seoVideos": 'videos',
                "seoKeywords1": "restaurants, establishments, restaurant in",
                "seoKeywords2": ", bar, club, tavern, pizza, pizzeria, summer gardens, wedding restaurants, children's corner restaurants, book a table, reservations, order food, bars, nightclubs",
                "seoKeywordsMap": "map, location, address, establishments, restaurants, taverns, private, corporate, parties, prom, birthday, baptism, wedding, business meeting, summer gardens",
                "seoDescriptionCity1": 'Restaurants, bars and clubs in',
                "seoDescriptionCity2": " Book online, order for home delivery. Selected venues, breweries, wedding and private party restaurants.",
                "seoDescriptionMap": ` Location of favorite restaurants for private and corporate parties, prom, birthday, weddings. Venues with summer gardens.`,
                "seoDescriptionAlt" : 'Restaurants, bars and clubs. Book a table, order food',
                "seoDescriptionOg": 'Bulgarian favorite restaurants, bar, taverns and clubs in Sofia, Plovdiv, Varna. Wedding restaurants, venues for corporate and private parties. Reserve a table. Order food delivery',
                "seoSiteName" : 'Zavedenia',
                //top
                "topMediterraneanKitchen": 'Best mediterranean restaurants',
                "topClubs": 'Top night clubs',
                "topClassVenues": 'Best fine dining restaurants',
                "topClassVenuesVarna": 'Best restaurants',
                "topPizza": 'Best pizza places',
                "topBulgarianPub": 'Best taverns',
                "topBars": 'Best bars',
                "topDelivery": 'Top delivery places',
                "beerVenues": 'Top venues for beer',
                "topBarAndDinner": 'Top bar and dinner venues',
                "fishRestourants": 'Top fish venues',
                "top25": 'TOP 25 restaurants and clubs',
                "seoTitle1": 'Restaurants',
                "seoTitle2": 'Zavedenia',
                "emptyList": "There are no results here anymore. Try changing your filter or selecting a different category.",
                "interestingFromZavedenia": "Interesting from Zavedenia and Sofia"
            },
            "gr": {
                //days of the week
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday",
                // 1.11.2021 en
                "venueCategories": "Категории заведения",
                "program": "Програма",
                "partyPeople": "Парти Снимки",
                "ownersLogin": "Вход за собственици",
                //

                "searchByCuisine": "Search by cuisine type",
                "searchPlaceHolder": "Search for restaurants, type or kitchen",
                "fineDining": "Fine Dining",
                "ad": "Реклама",
                "orderFood": "Поръчай храна",
                "venues": "ресторанти, пицарии, барове, клубове",
                "zavedeniaBG": "Zavedenia",
                "foodForHome": "Храна за вкъщи",
                "bookTable": "Резервирай маса",
                "lang": "GR",

                "european": "European",
                "grill": "Grill, BBQ",
                "italian": "Italian",
                "asian": "Asian",
                "arabian": "Arabic",
                "bulgarian": "Bulgarian",
                "oriental": "Oriental",
                "sushi": "Sushi",
                "mediterranean": "Mediterranean",
                "latin": "Latinamerican",
                "streetFood": "Street Food",
                "fastFood": "Fast Food",
                "turkishFood": "Turkish",
                "sandwiches": "Sandwiches",
                "serbianFood": "Serbian",
                "international": "International",
                "japanese": "Japanese",
                "seafood": "Sea Food",
                "american": "American",
                "greek": "Greek",
                "burgers": "Burgers",
                "vegetarian": "Veganvegetarian",
                "indian": "Indian",
                "balkan": "Balkan",

                "profile": "ΠΡΟΦΙΛ",
                "menu": "ΜΕΝΟΥ",
                "info": "ΠΛΗΡΟΦΟΡΙΕΣ",
                "login": "Σύνδεση",
                "createProfile": "Create Account",
                "back": "Πίσω",
                "close": "Κλείσιμο",
                "username": "Όνομα Χρήστη",
                "password": "Κωδικός",
                "emptyPassword": "Δεν έχετε εισάγει τον κωδικό",
                "errorPasswordShort": "???",
                "emptyUsername": "Δεν έχετε εισάγει το όνομα χρήστη",
                "sendPassword": "Αποστολή κωδικού",
                "forgottenPassword": "Ξεχάσατε τον κωδικό σας",
                "withoutRegistration": "Δεν έχετε λογαριασμό",
                "orderIsAcceptedStatusOne": "Η παραγγελία σας έχει αποσταλεί! Περιμένετε για επιβεβαίωση ότι έχει ληφθεί",
                "orderIsAcceptedStatusTwo": "Η παραγγελία σας έχει γίνει δεκτή! Αναμείνετε την παράδοση",
                "registrationForm": "Εγγραφή",
                "name": "Όνομα",
                "names": "Όνομα",
                "email": "Email",
                "emptyEmail": "Δεν έχετε εισάγει το email σας",
                "wrongEmail": "Το email δεν είναι έγκυρο",
                "subtotal": "Subtotal",
                "usedEmail": "Αυτό το email έχει ήδη λογαριασμό",
                "shippingArea": "Περιοχή παραλαβής",
                "chooseCity": "Choose city",
                "chooseArea": "Choose your area",
                "shippingAddress": "Διεύθυνση παραλαβής",
                "emptyAddress": "Δεν έχετε εισάγει διεύθυνση",
                "phoneForContacts": "Τηλέφωνο επικοινωνίας",
                "emptyPhone": "Δεν έχετε εισάγει τηλέφωνο",
                "next": "Συνέχεια",
                "quantity": "Ποσότητα",
                "comment": "Παρατήρηση",
                "toTheBasket": "Καλάθι",
                "myFavorite": "Τα αγαπημένα μου",
                "youAddedAddress": "Διεύθυνση προστέθηκε με επιτυχία",
                "area": "Περιοχή",
                "selectArea": "Επιλέξετε περιοχή",
                "address": "Διεύθυνση",
                "phone": "Τηλέφωνο",
                "save": "Αποθήκευση",
                "itemsInTheBasket": "Προϊόντα στο καλάθι",
                "basketIsEmpty": "Το καλάθι είναι άδειο",
                "productsPrice": "Τιμή προϊόντων",
                "boxes": "Κουτιά και συσκευασίες",
                "discount": "Έκπτωση",
                "shippingPrice": "Κόστος παράδοσης",
                "sum": "Σύνολο",
                "shippingInfo": "Πληροφορίες παράδοσης",
                "changeMainAddress": "Αλλαγή της κύριας διεύθυνσης",
                "buy": "Αγορά",
                "emptyTheBasket": "Άδειασε το καλάθι",
                "shippingAddressIsChanged": "Η διεύθυνση παράδοσης αλλάχθηκε με επιτυχία",
                "yourAddressIsChanged": "Η διεύθυνση σας αλλάχθηκε με επιτυχία",
                "yourProfileIsChanged": "Το προφίλ σας αλλάχθηκε με επιτυχία",
                "mainAddress": "Κύρια διεύθυνση",
                "editMainAddress": "Επεξεργασία κύριας διεύθυνσης",
                "addAddress": "Πρόσθεσε καινούργια διεύθυνση",
                "logout": "Σύνδεση με άλλο λογαριασμό",
                "workingTime": "Ωράριο λειτουργίας",
                "shippings": "Παράδοση",
                "passwordIsSended": "Ο κωδικός έχει σταλεί στο email σας",
                "withoutShipping": "Δυστυχώς σε αυτή τη περιοχή δεν κάνουμε παράδοση",
                "withoutShippingNow": "Το κατάστημα δεν λειτουργεί αυτή τη στιγμή! Ώρες και ημέρες λειτουργίας μπορείτε να δείτε στις ΠΛΗΡΟΦΟΡΙΕΣ",
                "pleaseSingin": "Για να χρησιμοποιήσετε την εφαρμογή θα πρέπει να είστε συνδεδεμένοι",
                "itemIsAdded": "Προσθέσατε προϊόν στο καλάθι!",
                "tryAgain": 'Υπήρξε ένα σφάλμα κατά την αποστολή της παραγγελίας σας! Παρακαλούμε πατήστε ξανά το κουμπί "Αγορά" μετά από λίγα δευτερόλεπτα',
                "sumIsNotOne": "Δεν έχετε φθάσει το ποσό των ",
                "sumIsNotTwo": " € για να παραληφθεί η παραγγελία",
                "leavecomment": "Παρατήρηση",
                "lv": "€",
                "price": "Τιμή",
                "open": "Отворено",
                "closed": "Затворено",
                "backToMenu": "Обратно към Менюто",
                "changeAddress": "Change address",
                "addressIsRequired": "Address is required",
                "gr": 'гр',
                "ml": 'мл',
                "br": 'бр',
                "couldOpen1": "Заведението все още не работи, НО може да поръчате.",
                "couldOpen2": "може да видите кога отваря.",
                "noPlaceOrder": "Заведението не предлага доставака на място!",
                "addressNotMatch": 'Адресът ви не е в зоната за доставка!',
                "address_enter": 'Въведи адрес (без етаж/апт)',
                "TakeFromVenueOrDeliveryZone": 'Взимане на място или доставка в следните квартали',
                "TakeFromVenueOrDelivery": 'Взимане на място или доставка до адрес',
                "searchInputPlaceHolder": 'Search Nearest Location',
                //SEO
                "seoMenu": 'меню',
                "seoNews": 'новини',
                "seoOffers": 'оферти',
                "seoEvents": 'събития',
                "seoPictures": 'снимки',
                "seoVideos": 'видео',
                "seoKeywords1": 'ресторанти, заведения, ресторант в ',
                "seoKeywords2": ', бар, клуб, механа, пица, пицария, летни градини, ресторанти сватба, ресторанти детски кът, резервирай маса, резервации, поръчай храна, барове, нощни клубове',
                "seoKeywordsMap": 'карта, локация, адрес, заведения, ресторанти, механи, частни, фирмени, партита, абитуриентски бал, рожден ден, кръщене, сватба, бизнес среща, летни, градини',
                "seoDescriptionCity1": 'Ресторанти, барове, клубове в ',
                "seoDescriptionCity2": '.  Резервирай онлайн, поръчай за вкъщи. Избрани механи, бирарии, ресторанти за сватби, фирмени и частни партита.',
                "seoDescriptionMap": ` Локация любими ресторанти за частни и фирмени партита, абитуриентски бал, рожден ден, сватби. Заведения с летни градини.`,
                "seoDescriptionAlt" : 'Ресторанти, барове, клубове',
                "seoDescriptionOg": 'Известни, луксозни, любими ресторанти, барове, клубове. Ресторанти за сватби, фирмени и частни партита. Резервирай маса. Поръчай за вкъщи',
                "seoSiteName" : 'Zavedenia',
                ///missing
                "allcatvenues": "ВСИЧКИ КАТЕГОРИИ ЗАВЕДЕНИЯ",

            },
            "tu": {
                //days of the week
                "monday": "Monday",
                "tuesday": "Tuesday",
                "wednesday": "Wednesday",
                "thursday": "Thursday",
                "friday": "Friday",
                "saturday": "Saturday",
                "sunday": "Sunday",
                // Added by Elli - START
                "search": "Arama",
                "venue": "Mekan",
                "by": "Tarafından",
                "category": "Kategori",
                "blog": "Blog",
                "for": "İçin",
                "type": "Tip",
                "kitchen": "Mutfağı",
                "theBusiness": "İş",
                "sofia": "Sofia",
                "plovdiv": "Plovdiv",
                "varna": "Varna",
                "burgas": "Burgas",
                "tarnovo": "Veliko Tarnovo",
                "bansko": "Basnko",
                "skopje": "Skopje",
                "beograd": "Belgrad",
                "others": "Diğerleri",
                "home": "Ana Sayfa",
                "city": "Şehir",
                "choose": "Seçin",
                "searchByCuisine": "Mutfak türüne göre arama",
                "searchPlaceHolder": "Search for restaurants, type or kitchen",
                "fineDining": "Fine Dining",
                "european": "Avrupalı",
                "grill": "Izgara, Barbekü",
                "italian": "İtalyanca",
                "asian": "Asyalı",
                "arabian": "Arapça",
                "bulgarian": "Bulgarca",
                "oriental": "Oryantal",
                "sushi": "Suşi",
                "mediterranean": "Akdeniz",
                "latin": "Latin Amerika",
                "streetFood": "Street Food",
                "fastFood": "Fast Food",
                "turkishFood": "Turkish Cuisine",
                "sandwiches": "Sandwiches",
                "serbianFood": "Serbian",
                "international": "International",
                "japanese": "Japanese",
                "seafood": "Sea Food",
                "american": "American",
                "greek": "Greek",
                "burgers": "Burger",
                "vegetarian": "Vegan-vejetaryen",
                "indian": "Hintli",
                "balkan": "Balkan",
                "ad": "Ilan",
                "orderFood": "Yemek sipariş etmek",
                "venues": "restoranlar, pizzalar, barlar",
                "zavedeniaBG": "Zavedenia",
                "foodForHome": "Yemek siparişi ver",
                "bookTable": "Masa ayırtın",
                "lang": "TU",
                // END


                //SEO
                "seoMenu": 'меню',
                "seoNews": 'новини',
                "seoOffers": 'оферти',
                "seoEvents": 'събития',
                "seoPictures": 'снимки',
                "seoVideos": 'видео',
                "seoKeywords1": 'ресторанти, заведения, ресторант в ',
                "seoKeywords2": ', бар, клуб, механа, пица, пицария, летни градини, ресторанти сватба, ресторанти детски кът, резервирай маса, резервации, поръчай храна, барове, нощни клубове',
                "seoKeywordsMap": ', карта, локация, адрес, заведения, ресторанти, механи, частни, фирмени, партита, абитуриентски бал, рожден ден, кръщене, сватба, бизнес среща, летни, градини',
                "seoDescriptionCity1": 'Ресторанти, барове, клубове в ',
                "seoDescriptionCity2": '.  Резервирай онлайн, поръчай за вкъщи. Избрани механи, бирарии, ресторанти за сватби, фирмени и частни партита.',
                "seoDescriptionMap": ` Локация любими ресторанти за частни и фирмени партита, абитуриентски бал, рожден ден, сватби. Заведения с летни градини.`,
                "seoDescriptionAlt" : 'Ресторанти, барове, клубове',
                "seoDescriptionOg": 'Известни, луксозни, любими ресторанти, барове, клубове. Ресторанти за сватби, фирмени и частни партита. Резервирай маса. Поръчай за вкъщи',
                "seoSiteName" : 'Zavedenia',
                  ///missing
                "allcatvenues": "ВСИЧКИ КАТЕГОРИИ ЗАВЕДЕНИЯ",
            },
            "mk": {
                // денови во неделата
                "monday": "понеделник",
                "tuesday": "вторник",
                "wednesday": "среда",
                "thursday": "четврток",
                "friday": "петок",
                "saturday": "сабота",
                "sunday": "недела",
                // ново 10.2021
                "restaurants": "ресторани",
                "allcatvenues": "СИТЕ КАТЕГОРИИ НА ЗАВЕДЕНИЈА",
                "topic": "Прилики",
                "musictype": "Музика",
                "footerInfo1": "booky.mk - онлајн каталог за ресторани и барови во Скопје",
                "footerInfo2": "Изберете ресторан, бар, клуб, таверна, пицерија. Резервирајте маса. Погледнете тековни понуди и настани. Ресторани за специјални прилики, со различни видови кујна.",
                "footerForClients": "За клиенти",
                "footerForPartners": "За партнери",
                "footerAbout": "За нас",
                "footerFollowUs": "Следете не",
                "footerSites": "Наши сајтови",
                "addVenue": "Додади ресторан",
                "help": "ЧПП",
                "feedback": "Повратни информации",
                "forInvestors": "За инвеститори",
                "development": "Развој",
                "termsOfUse": "Услови на користење",
                "personalData": "Лични податоци",
                "contacts": "Контакти",
                "downloadOurApp": "Преземете ја нашата апликација за ресторани и барови",
                "zavedeniaApp": "Апликацијата Z ќе ви помогне да најдете најблиски ресторани, барови, клубови. Проверете ги понудите. Изберете ресторан. Резервирајте маса.",
                "zavedenia": "Заведенија",
                "lastPosts": "Последни објави",
                "seeAll": "види ги сите",
                "mostViewed": "Најгледани",
                "seeOurBlog": "Погледнете ја нашата блог страница",
                "seeMore": "Види повеќе",
                "recommended": "Препорачано",
                "selectedForYou": "Избрано за Вас",
                "lastActive": "Последно активни",
                "lastAdded": "Последно ажурирани",
                "lastReservations": "Последни резервации",
                "lastVisited": "Последно посетени профили",
                "makeReservation": "направи резервација",
                "changeLang": "EN",
                "changeLangBG": "BG",
                "all": "Сите",
                "resultsFor": "Резултати за",
                "noResults": "Нема пронајдени резултати за:",
                "seats": "Седишта",
                "capacityIn": "внатре",
                "capacityOut": "надвор",
                "prices": "Цени",
                "website": "Веб-страница",
                "openMap": "Отвори мапа",
                "map": "Мапа",
                "list": "Листа",
                "aboutVenue": "За ресторанот",
                "hideDesc": "Скриј опис",
                "notAddedInfo": "Ресторанот сè уште нема објавено информации.",
                "comingInfoSoon": "Информации наскоро. Дознајте повеќе на наведениот телефон.",
                "thankUnderstanding": "Ви благодариме за разбирањето.",
                "suitableFor": "Погодно за",
                "typeVenue": "Тип на ресторан",
                "extras": "Екстри",
                "events": "Настани",
                "news": "Вести",
                "photos": "Фотографии",
                "offers": "Понуди",
                "comments": "Коментари",
                "video": "Видео",
                "seeTheArticle": ".. види статија",
                "CommentBook": "Книга на гости",
                "leaveComment": "остави коментар",
                "from": "од",
                "Manager": "од Менаџер",
                "ThematicGalleries": "Тематски галерии",
                // крај ново
                // 1.11.2021 mk
                "venueCategories": "Категории на заведенија",
                "program": "Програма",
                "partyPeople": "Парти фотографии",
                "ownersLogin": "Најава за сопственици",
                //
                "search": "Пребарување",
                "venue": "Заведение",
                "venueZav": "заведение",
                "by": "Од",
                "category": "Категорија",
                "blog": "Блог",
                "for": "За",
                "type": "Тип",
                "kitchen": "Кујна",
                "theBusiness": "Бизнисот",
                "sofia": "Софија",
                "plovdiv": "Пловдив",
                "varna": "Варна",
                "burgas": "Бургас",
                "tarnovo": "Велико Търново",
                "bansko": "Банско",
                "skopje": "Скопје",
                "beograd": "Белград",
                "others": "Други",
                "home": "Дома",
                "city": "Град",
                "choose": "Избери",
                "searchByCuisine": "Пребарување по тип на кујна",
                "searchPlaceHolder": "Пребарувај ресторани, тип или кујна",
                "fineDining": "Fine dining",
                "european": "Европска",
                "grill": "Скара",
                "italian": "Италијанска",
                "asian": "Азијска",
                "arabic": "Арапска",
                "bulgarian": "Македонска",
                "oriental": "Ориентална",
                "sushi": "Суши",
                "mediterranean": "Медитеранска",
                "latin": "Латиноамериканска",
                "streetFood": "Улична храна",
                "fastFood": "Брза храна",
                "turkishFood": "Турска",
                "sandwiches": "Сендвичи",
                "serbianFood": "Српска",
                "international": "Меѓународна",
                "japanese": "Јапонска",
                "seafood": "Морска храна",
                "american": "Американска",
                "greek": "Грчка",
                "burgers": "Бургери",
                "vegetarian": "Вегетаријанска - веган",
                "indian": "Индиска",
                "balkan": "Балканска",
                "ad": "Реклама",
                "orderFood": "Нарачај храна",
                "venues": "ресторани, пицерии, барови, пабови",
                "zavedeniaBG": "Заведенија",
                "foodForHome": "Нарачај храна",
                "bookTable": "Резервирај маса",
                "lang": "EN",
                "profile": "Профил",
                "menu": "Мени",
                "info": "Инфо",
                "moreinfo": "Повеќе информации",
                "login": "Најава",
                "createProfile": "Креирај профил",
                "forgotten": "Заборавена лозинка",
                "back": "Назад",
                "backToMenu": "Назад кон менито",
                "close": "Затвори",
                "username": "Корисничко име",
                "password": "Лозинка",
                "myOrder": "Моја нарачка",
                "changeAddress": "Промени адреса",
                "emptyPassword": "Не сте додале лозинка",
                "errorPasswordShort": "Лозинката е прекратка",
                "emptyUsername": "Не сте додале корисничко име",
                "sendPassword": "Испрати лозинка",
                "forgottenPassword": "Заборавена лозинка",
                "withoutRegistration": "Без регистрација",
                "orderIsAcceptedStatusOne": "Вашата нарачка се обработува...",
                "orderIsAcceptedStatusTwo": "Вашата нарачка е прифатена!",
                "registrationForm": "Форма за регистрација",
                "name": "Име",
                "names": "Имиња",
                "email": "Е-пошта",
                "subtotal": "Меѓузбир",
                "addressIsRequired": "Адресата е задолжителна",
                "emptyEmail": "Не сте додале е-пошта",
                "wrongEmail": "Е-поштата е невалидна",
                "usedEmail": "Е-поштата веќе се користи",
                "shippingArea": "Област",
                "chooseCity": "Избери град",
                "chooseArea": "Избери област",
                "shippingAddress": "Адреса",
                "emptyAddress": "Не сте додале адреса",
                "phoneForContacts": "Телефонски број",
                "emptyPhone": "Мора да додадете телефонски број",
                "next": "Следно",
                "price": "Цена",
                "quantity": "Количина",
                "comment": "Коментар",
                "toTheBasket": "Во кошничка",
                "myFavorite": "Мои омилени нарачки",
                "youAddedAddress": "Успешно додадовте адреса!",
                "area": "Област",
                "selectArea": "Избери област",
                "address": "Адреса",
                "phone": "Телефон",
                "save": "Зачувај",
                "commentFoodNotes": "Дополнителни белешки",
                "itemsInTheBasket": "Ставки во кошничката",
                "basketIsEmpty": "Кошничката е празна",
                "productsPrice": "Цена на производите",
                "boxes": "Кутија и пакување",
                "discount": "Остварен попуст",
                "shippingPrice": "Достава",
                "sum": "Вкупно",
                "shippingInfo": "Информации за достава",
                "changeMainAddress": "Промени ја главната адреса",
                "emptyTheBasket": "Испразни ја кошничката",
                "shippingAddressIsChanged": "Успешно ја променивте адресата за достава",
                "yourAddressIsChanged": "Успешно ја променивте адресата",
                "yourProfileIsChanged": "Успешно го променивте профилот",
                "mainAddress": "Главна адреса",
                "editMainAddress": "Измени главна адреса",
                "addAddress": "Додај нова адреса",
                "logout": "Одјави се",
                "workingTime": "Работно време",
                "shippings": "Прифаќа нарачки за достава",
                "passwordIsSended": "Лозинката е успешно испратена на вашата е-пошта",
                "withoutShipping": "За жал, не вршиме достава во бараното подрачје",
                "withoutShippingNow": "Локалот не прифаќа нарачки во овој период! Работно време и денови за достава се достапни во делот „ИНФО“",
                "pleaseSinginWithPayment": "Дали сакате да се регистрирате со е-пошта?\nПлаќањето со картичка е можно само со регистрација.",
                "pleaseSingin": "Дали сакате да се регистрирате со е-пошта?",
                "itemIsAdded": "Додадовте ставка!",
                "tryAgain": "Се случи грешка при испраќањето на нарачката! Обидете се повторно со клик на копчето „Нарачај“ за неколку секунди",
                "sumIsNotOne": "Немате достигнато минимален износ од ",
                "sumIsNotTwo": " денари за да може да се прифати нарачката",
                "leavecomment": "Оставете коментар за нарачката",
                "lv": "ден",
                "pay": "Плати со картичка",
                "orderCash": "Плати со готовина",
                "orderCard": "Плати со картичка",
                "totalWithDelivery": "СО ДОСТАВА",
                "totalPickUp": "СО ПОДИГНУВАЊЕ",
                "orderfoodhome": "Нарачај храна за дома",
                "doesNotDeliver": "Не можеме да доставиме во вашето подрачје :(",
                "minimalOrder": "МИНИМАЛЕН ИЗНОС ЗА НАРАЧКА:",
                "order": "Нарачај",
                "visits": "Посети",
                "discountShort": "Попуст",
                "plasticBox": "Пакување:",
                "emptyBasket": "Испразни кошничка",
                "codeTimeMessage": "Внесете го кодот тука",
                "codeResend": "Ве молиме испратете го кодот повторно.",
                "codeTypeIt": "Внесете го кодот за верификација",
                "checkCode": "Провери го кодот",
                "getCode": "Испрати ми нов код",
                "placeholderCode": "Внеси го твојот код тука",
                "continueNoReg": "Продолжи без регистрација",
                "registerDiscount": " ",
                "change": "Измени",
                "termsAgreement": "Се согласувам со условите и политиката за приватност",
                "paywithcardMessage": "Може да платите со картичка",
                "commentAdditionalInfo": "Напишете кат/стан или други детали во полето.",
                "lastOrderButton": "ВАШАТА НАРАЧКА",
                "logWithEmail": "Сакам да се регистрирам",
                "dontLogMe": "Ќе направам брза нарачка",
                "naberRestriction": "Не можеме да доставиме во вашето подрачје :(",
                "enterAddress": "Внесете адреса",
                "enterYourAddress": " внесете ја вашата адреса тука",
                "noOrderInTheMoment": "Во моментот не вршиме достава :(",
                "quantityCount": "пар.",
                "deliveryOnPlaceByVenueComment": "Оставете точна адреса и дополнителни информации во полето за коментар подолу!",
                "take": "Подигни",
                "taken": "Подигнато",
                "registration": "Регистрација",

                "takeOnPlace": "од ресторанот",
                "orOrderFor": " или нарачај за ",
                "homeOrOffice": " достава",
                "orderPromotion1608": "Нарачај 2 пици 30 см, добиј Маргарита бесплатно",
                "shippingFrom": "Достава од ",
                "freeDeliveryPlus": "Бесплатна достава ",
                "DISCOUNT": "ПОПУСТ",
                "ORDERS": "НАРАЧКИ",
                "onquestions": "Ако имате прашања:",
                "ORDER": "Нарачај",
                "orderIsPayed": "Вашата нарачка е платена! Ви благодариме.",
                "ALL": "Вкупно",
                "bannerPromotionVenue": "Нарачај тука и добиј попуст",
                "bannerPromotionVenueMinPriceDiscount": "Важи само за нарачки над ",
                "orOrderIn": " или достава ",
                "or": "или",
                "orDeliveryUpTo": " достава до дома.",
                "infoFooterDescriptionFirstParagraph": "ORDER.BG е услуга на ZAVEDENIA.BG и е заедничка платформа за нарачка на храна.",
                "infoFooterDescriptionSecondParagraph": "Доколку плативте онлајн и имате прашања во врска со трансакцијата, контактирајте не на ",
                "open": "Отворено",
                "closed": "Затворено",
                "keywordss": "нарачај храна, храна за дома, достава на храна, достава до канцеларија, нарачка, достава, за дома, храна, јадења, ручек, вечера, Скопје, Битола, Охрид",
                "descriptionn": "Нарачај храна од омилените ресторани и кујни. Превземи храна или доставуваме до твојот дом Скопје, Битола, Охрид",
                "verifyHeader": "Кликнете на копчето за да добиете код преку СМС.",
                "verifySentence": "Ве молиме испратете го кодот повторно!",
                "verifySentence2": "Премногу обиди. Обидете се со друг телефон.",
                "verifywrongcode": "Го испративме кодот, проверете ги вашите СМС пораки или обидете се повторно.",
                "verifywrongcode2": "Погрешен код, обидете се повторно",
                "sendverifycode": "Испрати ми код!",
                "enterverifycode": "Внеси код тука",
                "checkverifycode": "Провери го кодот",
                "noDeliveryCalculated": "Доставата се пресметува во кошничката",
                "gr": "гр",
                "ml": "мл",
                "br": "пар",
                "couldOpen1": "Сè уште сме затворени, но можете да нарачате однапред.",
                "couldOpen2": " Наскоро ќе отвориме.",
                "noPlaceOrder": "Не нудиме услуга за подигнување.",
                "addressNotMatch": "Вашата адреса не е во зоната за достава!",
                "address_enter": "Внесете ја вашата адреса (улица и број)",
                "TakeFromVenueOrDeliveryZone": "Подигни од локал или користи достава до следните населби",
                "TakeFromVenueOrDelivery": "Подигни од локал или користи достава до точна адреса",
                "searchInputPlaceHolder": "Пребарај ја твојата адреса",
                "emptyList": "Тука веќе нема резултати.Пробајте да го смените вашиот филтер или изберете друга категорија.",
                "interestingFromZavedenia": "Interesting from Zavedenia and Sofia",
                "seoTitle1": "Ресторани, барови, клубови во ",
                "seoTitle2": ". Резервирај онлајн, нарачка за дома. Избрани ресторани, таверни, барови, клубови, пицерии, летни градини. Ресторани за сватби, родендени, бизнис настани.",
            },
            "sr":{
                            //days of the week
                            "monday": "Ponedeljak",
                            "tuesday": "Utorak",
                            "wednesday": "Sreda",
                            "thursday": "Četvrtak",
                            "friday": "Petak",
                            "saturday": "Subota",
                            "sunday": "Nedelja",
                            // new 10.2021
                            "restaurants": "Restorani",
                            "allcatvenues": "SVE KATEGORIJE OBJEKATA",
                            "topic": "Prilike",
                            "musictype": "Muzika",
                            "footerInfo1": "booky.sr - online katalog restorana i barova u Beograd",
                            "footerInfo2": "Izaberite restoran, bar, klub, kafanu, piceriju. Rezervišite sto. Pogledajte trenutne ponude i događaje. Restorani za posebne prilike, sa različitim vrstama kuhinje.",
                            "footerForClients": "Za klijente",
                            "footerForPartners": "Za partnere",
                            "footerAbout": "O nama",
                            "footerFollowUs": "Zaprati nas",
                            "footerSites": "Naši sajtovi",
                            "addVenue": "Dodaj restoran",
                            "help": "Pitanja i odgovori",
                            "feedback": "Povratne informacije",
                            "forInvestors": "Za investitore",
                            "development": "Razvoj",
                            "termsOfUse": "Uslovi korišćenja",
                            "personalData": "Lični podaci",
                            "contacts": "Kontakt",
                            "downloadOurApp": "Preuzmi našu aplikaciju za restorane i barove",
                            "zavedeniaApp": "Aplikacija Z će vam pomoći da pronađete najbliže restorane, barove, klubove. Pogledajte ponude. Izaberite restoran. Rezervišite sto.",
                            "zavedenia": "Objekti",
                            "lastPosts": "Poslednje objave",
                            "seeAll": "pogledaj sve",
                            "mostViewed": "Najgledanije",
                            "seeOurBlog": "Pogledaj naš blog",
                            "seeMore": "Pogledaj više",
                            "recommended": "Preporučeno",
                            "selectedForYou": "Izabrano za vas",
                            "lastActive": "Poslednje aktivno",
                            "lastAdded": "Poslednje ažurirano",
                            "lastReservations": "Nedavne rezervacije",
                            "lastVisited": "Poslednje posećeni profili",
                            "makeReservation": "napravi rezervaciju",
                            "changeLang": "EN",
                            "changeLangBG": "BG",
                            "all": "Sve",
                            "resultsFor": "Rezultati za",
                            "noResults": "Nema rezultata za:",
                            "seats": "Mesta",
                            "capacityIn": "unutra",
                            "capacityOut": "napolju",
                            "prices": "Cene",
                            "website": "Vebsajt",
                            "openMap": "Otvori mapu",
                            "map": "Mapa",
                            "list": "Lista",
                            "aboutVenue": "O restoranu",
                            "hideDesc": "Sakrij opis",
                            "notAddedInfo": "Restoran još nije postavio informacije.",
                            "comingInfoSoon": "Informacije uskoro. Više saznajte putem navedenog telefona.",
                            "thankUnderstanding": "Hvala na razumevanju.",
                            "suitableFor": "Pogodno za",
                            "typeVenue": "Tip restorana",
                            "extras": "Dodaci",
                            "events": "Događaji",
                            "news": "Vesti",
                            "photos": "Fotografije",
                            "offers": "Ponude",
                            "comments": "Komentari",
                            "video": "Video",
                            "seeTheArticle": ".. pogledaj članak",
                            "CommentBook": "Knjiga gostiju",
                            "leaveComment": "ostavi komentar",
                            "from": "od",
                            "Manager": "od menadžera",
                            "ThematicGalleries": "Tematske galerije",
                // end new
                // 1.11.2021 en
                "venueCategories": "Kategorije objekata",
                "program": "Program",
                "partyPeople": "Žurke - slike",
                "ownersLogin": "Prijava za vlasnike",
                //
                "search": "Pretraga",
                "venue": "Objekat",
                "venueZav": "objekat",
                "by": "Od",
                "category": "Kategorija",
                "blog": "Blog",
                "for": "Za",
                "type": "Tip",
                "kitchen": "Kuhinja",
                "theBusiness": "Biznis",
                "sofia": "Sofija",
                "plovdiv": "Plovdiv",
                "varna": "Varna",
                "burgas": "Burgas",
                "tarnovo": "Veliko Tarnovo",
                "bansko": "Bansko",
                "skopje": "Skoplje",
                "beograd": "Beograd",
                "others": "Ostali",
                "home": "Početna",
                "city": "Grad",
                "choose": "Izaberi",
                "searchByCuisine": "Pretraga po vrsti kuhinje",
                "searchPlaceHolder": "Pretraži restorane, tip ili kuhinju",
                "fineDining": "Gurmanski restoran",
                "european": "Evropska",
                "grill": "Roštilj, BBQ",
                "italian": "Italijanska",
                "asian": "Azijska",
                "arabic": "Arapska",
                "bulgarian": "Srpska",
                "oriental": "Orijentalna",
                "sushi": "Suši",
                "mediterranean": "Mediteranska",
                "latin": "Latinsko-američka",
                "streetFood": "Ulična hrana",
                "fastFood": "Brza hrana",
                "turkishFood": "Turska",
                "sandwiches": "Sendviči",
                "serbianFood": "Srpska",
                "international": "Internacionalna",
                "japanese": "Japanska",
                "seafood": "Morski plodovi",
                "american": "Američka",
                "greek": "Grčka",
                "burgers": "Burgeri",
                "vegetarian": "Veganska - vegetarijanska",
                "indian": "Indijska",
                "balkan": "Balkanska",
                "ad": "Oglasi",
                "orderFood": "Poruči hranu",
                "venues": "restorani, picerije, barovi, pabovi",
                "zavedeniaBG": "Zavedenia",
                "foodForHome": "Poruči hranu",
                "bookTable": "Rezerviši sto",
                "lang": "SR",

                "profile": "Profil",
                "menu": "Meni",
                "info": "Informacije",
                "moreinfo": "Više informacija",
                "login": "Prijavi se",
                "createProfile": "Kreiraj nalog",
                "forgotten": "Zaboravljena lozinka",
                "back": "Nazad",
                "backToMenu": "Nazad na meni",
                "close": "Zatvori",
                "username": "Korisničko ime",
                "password": "Lozinka",
                "myOrder": "Moja porudžbina",
                "changeAddress": "Promeni adresu",
                "emptyPassword": "Niste uneli lozinku",
                "errorPasswordShort": "Lozinka je prekratka",
                "emptyUsername": "Niste uneli korisničko ime",
                "sendPassword": "Pošalji lozinku",
                "forgottenPassword": "Zaboravljena lozinka",
                "withoutRegistration": "Bez registracije",
                "orderIsAcceptedStatusOne": "Vaša porudžbina se obrađuje...",
                "orderIsAcceptedStatusTwo": "Vaša porudžbina je prihvaćena!",
                "registrationForm": "Registraciona forma",
                "name": "Ime",
                "names": "Imena",
                "email": "Email adresa",
                "subtotal": "Međuzbir",
                "addressIsRequired": "Adresa je obavezna",
                "emptyEmail": "Niste uneli email adresu",
                "wrongEmail": "Neispravna email adresa",
                "usedEmail": "Email adresa je već u upotrebi",
                "shippingArea": "Oblast",
                "chooseCity": "Izaberi grad",
                "chooseArea": "Izaberi oblast",
                "shippingAddress": "Adresa",
                "emptyAddress": "Niste uneli adresu",
                "phoneForContacts": "Broj telefona",
                "emptyPhone": "Morate uneti broj telefona",
                "next": "Dalje",
                "price": "Cena",
                "quantity": "Količina",
                "comment": "Komentar",
                "toTheBasket": "U korpu",
                "myFavorite": "Moje omiljene porudžbine",
                "youAddedAddress": "Uspešno ste dodali adresu!",
                "area": "Oblast",
                "selectArea": "Izaberite oblast",
                "address": "Adresa",
                "phone": "Telefon",
                "save": "Sačuvaj",
                "commentFoodNotes": "Dodatne napomene",
                "itemsInTheBasket": "Stavke u korpi",
                "basketIsEmpty": "Korpa je prazna",
                "productsPrice": "Cena proizvoda",
                "boxes": "Pakovanje i kutije",
                "discount": "Popust",
                "shippingPrice": "Dostava",
                "sum": "Ukupno",
                "shippingInfo": "Informacije o dostavi",
                "changeMainAddress": "Promeni glavnu adresu",
                "emptyTheBasket": "Isprazni korpu",
                "shippingAddressIsChanged": "Uspešno ste promenili adresu za dostavu",
                "yourAddressIsChanged": "Uspešno ste promenili adresu",
                "yourProfileIsChanged": "Uspešno ste izmenili profil",
                "mainAddress": "Glavna adresa",
                "editMainAddress": "Izmeni glavnu adresu",
                "addAddress": "Dodaj novu adresu",
                "logout": "Odjavi se",
                "workingTime": "Radno vreme",
                "shippings": "Prihvatamo dostave",
                "passwordIsSended": "Vaša lozinka je uspešno poslata na vašu email adresu",
                "withoutShipping": "Nažalost ne dostavljamo u traženu oblast",
                "withoutShippingNow": "Objekat trenutno ne prihvata porudžbine! Radno vreme i dani dostave su u odeljku 'INFO'",
                "pleaseSinginWithPayment": "Želite li da se registrujete sa email adresom?\nPlaćanje karticom je moguće samo uz registraciju.",
                "pleaseSingin": "Želite li da se registrujete sa email adresom?",
                "itemIsAdded": "Dodali ste stavku!",
                "tryAgain": "Došlo je do greške pri slanju porudžbine! Pokušajte ponovo klikom na dugme 'Poruči' za nekoliko sekundi",
                "sumIsNotOne": "Niste dostigli minimalni iznos od ",
                "sumIsNotTwo": " din, kako bi porudžbina bila prihvaćena",
                "leavecomment": "Ostavite komentar uz porudžbinu",
                "lv": "din",
                "pay": "Plati karticom",
                "orderCash": "Plati gotovinom",
                "orderCard": "Plati karticom",
                "totalWithDelivery": "SA DOSTAVOM",
                "totalPickUp": "PREUZIMANJE",
                "orderfoodhome": "Poruči hranu za kuću",
                "doesNotDeliver": "Ne dostavljamo u vašu oblast :(",
                "minimalOrder": "MINIMALAN IZNOS PORUDŽBINE:",
                "order": "Poruči",
                "visits": "Posete",
                "discountShort": "Popust",
                "plasticBox": "Pakovanje:",
                "emptyBasket": "Isprazni korpu",
                "codeTimeMessage": "Unesite svoj kod ovde",
                "codeResend": "Ponovo pošaljite kod.",
                "codeTypeIt": "Unesite verifikacioni kod",
                "checkCode": "Potvrdi kod",
                "getCode": "Pošalji novi kod",
                "placeholderCode": "Unesite vaš kod ovde",
                "continueNoReg": "Nastavi bez registracije",
                "registerDiscount": " ",
                "change": "Izmeni",
                "termsAgreement": "Slažem se sa uslovima i politikom privatnosti sajta",
                "paywithcardMessage": "Možete platiti karticom",
                "commentAdditionalInfo": "Molimo napišite sprat/stani ili druge detalje u komentaru.",
                "lastOrderButton": "VAŠA PORUDŽBINA",
                "logWithEmail": "Želim da se registrujem",
                "dontLogMe": "Napravi brzu porudžbinu",
                "naberRestriction": "Ne dostavljamo u vašu oblast :(",
                "enterAddress": "Unesite adresu",
                "enterYourAddress": " unesite adresu ovde",
                "noOrderInTheMoment": "Trenutno ne dostavljamo :(",
                "quantityCount": "kom.",
                "deliveryOnPlaceByVenueComment": "Molimo unesite tačnu adresu i dodatne informacije u polje za komentar ispod!",
                "take": "Preuzmi",
                "taken": "Preuzeto",
                "registration": "Registracija",
                "takeOnPlace": "iz restorana",
                "orOrderFor": " ili poruči ",
                "homeOrOffice": " dostava",
                "orderPromotion1608": "Poruči 2 pice od 30 cm, dobijaš picu Margarita besplatno",
                "shippingFrom": "Dostava iz ",
                "freeDeliveryPlus": "Besplatna dostava ",
                "DISCOUNT": "POPUST",
                "ORDERS": "PORUDŽBINE",
                "onquestions": "Ako imate pitanja:",
                "ORDER": "Poruči",
                "orderIsPayed": "Vaša porudžbina je plaćena! Hvala vam.",
                "ALL": "Ukupno",
                "bannerPromotionVenue": "Poruči ovde i ostvari popust",
                "bannerPromotionVenueMinPriceDiscount": "Važi samo za porudžbine iznad ",
                "orOrderIn": " ili dostava ",
                "or": "ili",
                "orDeliveryUpTo": " dostava na kućnu adresu.",
                "infoFooterDescriptionFirstParagraph": "ORDER.BG je usluga ZAVEDENIA.BG i predstavlja zajedničku platformu za naručivanje hrane.",
                "infoFooterDescriptionSecondParagraph": "Ako ste platili online i imate pitanja o svojoj transakciji, kontaktirajte nas na ",
                "open": "Otvoreno",
                "closed": "Zatvoreno",
                "keywordss": "naruči hranu, hrana za kuću, dostava hrane, dostava u kancelariju, porudžbina, dostava, za kuću, hrana, jela, ručak, večera, Beograd",
                "descriptionn": "Naručite hranu iz omiljenog restorana i kuhinje. Hrana za poneti ili dostava na adresu u Beograd",
                "verifyHeader": "Pritisnite dugme da vam pošaljemo kod putem SMS-a.",
                "verifySentence": "Molimo pošaljite kod ponovo!",
                "verifySentence2": "Previše pokušaja. Pokušajte sa drugim telefonom.",
                "verifywrongcode": "Poslali smo kod, proverite SMS poruke ili pokušajte ponovo.",
                "verifywrongcode2": "Pogrešan kod, pokušajte ponovo",
                "sendverifycode": "Pošalji mi kod!",
                "enterverifycode": "Unesite kod ovde",
                "checkverifycode": "Proveri kod",
                "noDeliveryCalculated": "Dostava se obračunava u korpi",
                "gr": "gr",
                "ml": "ml",
                "br": "kom",
                "couldOpen1": "Još uvek smo zatvoreni, ali možete naručiti unapred.",
                "couldOpen2": " Uskoro otvaramo.",
                "noPlaceOrder": "Ne nudimo uslugu preuzimanja.",
                "addressNotMatch": "Vaša adresa nije u zoni dostave!",
                "address_enter": "Unesite svoju adresu (ulica i broj)",
                "TakeFromVenueOrDeliveryZone": "Preuzimanje ili dostava do sledećih naselja",
                "TakeFromVenueOrDelivery": "Preuzimanje ili dostava na ispravnu adresu",
                "searchInputPlaceHolder": "Pretražite vašu adresu",

                // BOOKING
                "bookingFormText1": "Rezerviši sto online",
                "bookingFormText2": "Online rezervacije preko booky.bg",
                "bookingFormText3": "Vaše informacije se odmah šalju lokalu",
                "bookingFormText4": "Dobijate potvrdu putem SMS-a",
                "bookingFormText5": "Dobijate podsetnik za vašu rezervaciju",
                "bookingFormText6": "Vaš komentar će biti direktno prosleđen menadžeru",

                // SEO
                "seoMenu": "meni",
                "seoNews": "vesti",
                "seoOffers": "ponude",
                "seoEvents": "događaji",
                "seoPictures": "slike",
                "seoVideos": "video",
                "seoKeywords1": "restorani, objekti, restoran u",
                "seoKeywords2": ", bar, klub, kafana, pica, picerija, letnje bašte, restorani za venčanja, restorani sa kutkom za decu, rezerviši sto, rezervacije, naruči hranu, barovi, noćni klubovi",
                "seoKeywordsMap": "mapa, lokacija, adresa, objekti, restorani, kafane, privatne, korporativne, proslave, maturske večeri, rođendani, krštenja, venčanja, poslovni sastanci, letnje bašte",
                "seoDescriptionCity1": "Restorani, barovi i klubovi u",
                "seoDescriptionCity2": " Rezervišite online, naručite hranu za dostavu. Izabrani objekti, pivare, restorani za venčanja i privatne zabave.",
                "seoDescriptionMap": " Lokacije omiljenih restorana za privatne i korporativne proslave, mature, rođendane, venčanja. Objekti sa letnjim baštama.",
                "seoDescriptionAlt": "Restorani, barovi i klubovi. Rezervišite sto, naručite hranu",
                "seoDescriptionOg": "Omiljeni bugarski restorani, barovi, kafane i klubovi u Sofiji, Plovdivu i Varni. Restorani za venčanja, prostori za privatne i poslovne proslave. Rezervišite sto. Naručite hranu.",
                "seoSiteName": "Zavedenia",

                // TOP
                "topMediterraneanKitchen": "Najbolji mediteranski restorani",
                "topClubs": "Top noćni klubovi",
                "topClassVenues": "Najbolji restorani visoke klase",
                "topClassVenuesVarna": "Najbolji restorani",
                "topPizza": "Najbolje picerije",
                "topBulgarianPub": "Najbolje kafane",
                "topBars": "Najbolji barovi",
                "topDelivery": "Top mesta za dostavu",
                "beerVenues": "Top mesta za pivo",
                "topBarAndDinner": "Top bar i večera mesta",
                "fishRestourants": "Top riblji restorani",
                "top25": "TOP 25 restorana i klubova",
                "seoTitle1": "Restorani, barovi, klubovi u ",
                "seoTitle2": "Zavedenia ",
                "emptyList": "Ovde više nema rezultata. Pokušajte da promenite filter ili izaberete drugu kategoriju.",
                "interestingFromZavedenia": "Interesting from Zavedenia and Sofia"
            }

        };
    }
    private getLanguageFromUrl(url: string): string {
      for (const langCode of Object.keys(this.SUPPORTED_LANGUAGES)) {
        if (url.includes(`/${langCode}`)) {
          return langCode;
        }
      }
      return this.DEFAULT_LANGUAGE;
    }
    getLang(): Observable<boolean> {
      return this.routerInfo.asObservable();
    }
    setLang(lang: any): void {
      this.routerInfo.next(lang);
    }
    setLanguage(languageCode: string): void {

      if (!this.SUPPORTED_LANGUAGES[languageCode]) {
        languageCode = this.DEFAULT_LANGUAGE;
      }
      const language = this.SUPPORTED_LANGUAGES[languageCode];
      this.language = language.code;
      this.localStorage.setItem('language', language.code);
      this.document.documentElement.lang = language.docLang;

      this.setLang(language.code === 'en');
    }

    getSupportedLanguages(): string[] {
      return Object.keys(this.SUPPORTED_LANGUAGES);
    }
    getCurrentLanguage(): Langs {
      return this.SUPPORTED_LANGUAGES[this.language];
    }

}

interface Langs {
  code: string;
  docLang: string;
}
